export const GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST = 'GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST';
export const GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST_SUCCESS = `${GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST}/SUCCESS`;
export const GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST_FAILURE = `${GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST}/FAILURE`;

export const GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST = 'GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST';
export const GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST_SUCCESS = `${GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST}/SUCCESS`;
export const GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST_FAILURE = `${GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST}/FAILURE`;

export const GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST = 'GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST';
export const GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST_SUCCESS = `${GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST}/SUCCESS`;
export const GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST_FAILURE = `${GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST}/FAILURE`;

export default {
  GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST,
  GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST_SUCCESS,
  GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST_FAILURE,

  GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST,
  GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST_SUCCESS,
  GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST_FAILURE,

  GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST,
  GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST_SUCCESS,
  GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST_FAILURE,
};
